/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Measures_Series_OneInputs */

const en_us2_body_measures_series_one = /** @type {(inputs: Body_Measures_Series_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`One reading so far. The line appears from the second.`)
};

const pt_br2_body_measures_series_one = /** @type {(inputs: Body_Measures_Series_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma medida até agora. A linha aparece a partir da segunda.`)
};

const es_419_body_measures_series_one = /** @type {(inputs: Body_Measures_Series_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Una medida hasta ahora. La línea aparece a partir de la segunda.`)
};

const pt_pt2_body_measures_series_one = /** @type {(inputs: Body_Measures_Series_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uma medida até agora. A linha aparece a partir da segunda.`)
};

const fr_fr2_body_measures_series_one = /** @type {(inputs: Body_Measures_Series_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une seule mesure pour l'instant. La courbe apparaît dès la deuxième.`)
};

const de_de2_body_measures_series_one = /** @type {(inputs: Body_Measures_Series_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bisher eine Messung. Die Linie erscheint ab der zweiten.`)
};

const it_it2_body_measures_series_one = /** @type {(inputs: Body_Measures_Series_OneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Finora una sola misura. La linea compare dalla seconda.`)
};

/**
* | output |
* | --- |
* | "One reading so far. The line appears from the second." |
*
* @param {Body_Measures_Series_OneInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_measures_series_one = /** @type {((inputs?: Body_Measures_Series_OneInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Measures_Series_OneInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_measures_series_one(inputs)
	if (locale === "es-419") return es_419_body_measures_series_one(inputs)
	if (locale === "pt-PT") return pt_pt2_body_measures_series_one(inputs)
	if (locale === "fr-FR") return fr_fr2_body_measures_series_one(inputs)
	if (locale === "de-DE") return de_de2_body_measures_series_one(inputs)
	if (locale === "it-IT") return it_it2_body_measures_series_one(inputs)
	return en_us2_body_measures_series_one(inputs)
});
export { body_measures_series_one as "body-measures.series_one" }